import { z } from 'zod'
import { MAX_USERNAME_LENGTH } from '../../../../const/inputs'

export const authSchema = z.object({
  username: z
    .string()
    .trim()
    .min(1, 'Wymagane pole')
    .max(
      MAX_USERNAME_LENGTH,
      `maksymalna ilość znaków to ${MAX_USERNAME_LENGTH}`
    ),
  password: z.string().trim().min(1, 'Wymagane pole')
})

export type Login = z.infer<typeof authSchema>
